<template>
  <vs-row v-if="elementToGiro != null && orderBy != null" vs-type="flex" vs-w="12" class="mt-1">
    <span v-for="(infoType, index) in infoTypes" :key="index" :class="{'text-primary' : index == 0}"
          class="text-secondary bold text-xsmall w-full text-center">
      {{ getGiroInfo(infoType) }}
    </span>
  </vs-row>
</template>

<script>
export default {
  props: {
    elementToGiro: {
      type: Object,
      required: true
    },
    orderBy: {
      type: Number,
      required: true
    }
  },
  name: "GiroInfo",
  data() {
    return {
      infoTypes: ["Ciro", "Adet", "Maaliyet", "Kar"]
    }
  },
  methods: {
    getGiroInfo(infoType) {
      var prefix = infoType + " : "
      var info = "";
      switch (infoType) {
        case "Ciro":
          info = this.$convertCurrency(this.elementToGiro.amount);
          break;
        case "Adet":
          info = this.elementToGiro.piece.toLocaleString()
          break;
        case "Maaliyet":
          info = this.$convertCurrency(this.elementToGiro.cost);
          break;
        case "Kar":
          info = this.$convertCurrency(this.elementToGiro.profit);
          break;
      }
      return prefix + info
    }
  },
  watch: {
    orderBy(val) {
      if (!val) return;
      let index = 0;
      switch (val) {
        case 0:
          index = this.infoTypes.findIndex(x => x == "Ciro");
          break;
        case 1:
          index = this.infoTypes.findIndex(x => x == "Adet");
          break;
        case 2:
          index = this.infoTypes.findIndex(x => x == "Maaliyet");
          break;
        case 3:
          index = this.infoTypes.findIndex(x => x == "Kar");
          break;
      }
      this.infoTypes.splice(0, 0, this.infoTypes.splice(index, 1)[0]);
    }
  }
}
</script>

<style scoped>

</style>
